// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"879ab048","787":"34726a30"}[chunkId] + ".chunk.js";
};